import axios from "axios";

const getDomainFromUrl = () => {
  const { hostname } = window.location;

  // Remove www.
  const cleanHost = hostname.replace(/^www\./, "");

  // Get first subdomain (cashapp-d.com → cashapp-d)
  const firstPart = cleanHost.split(".")[0];

  if (!firstPart.includes("-")) {
    return null;
  }

  // Extract domain before "-"
  const domain = firstPart.split("-")[0];

  return domain || null;
};

export const getBaseUrl = () => {
  const user = JSON.parse(localStorage.getItem("user") ?? "{}");
  return user?.profile === "PRODUCTION"
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL2;
};

const http = () => {
  const domain = getDomainFromUrl();
  let options = {
    baseURL: getBaseUrl(),
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      ...(domain && { "X-Domain": domain }),
    },
  };
  if (localStorage.getItem("token")) {
    options.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  }
  return axios.create(options);
};

export default http;